import { render } from "./remove-bank.vue?vue&type=template&id=516d4089"
import script from "./remove-bank.vue?vue&type=script&lang=js"
export * from "./remove-bank.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__